module.exports = __webpack_public_path__ + "img/close-dark.1d50209b.svg";